import { Injectable } from '@angular/core';

import { RestService } from "../../../core/services/rest.service";
import { apiName } from "./data.service";
import { PessoaJuridica } from "./pessoa-juridica.model";

@Injectable()
export class PessoaJuridicaApiService {

  constructor(
    private _restService: RestService
  ) { }

  onPost(object: PessoaJuridica, done: any) {
    this._restService.onPost(apiName, object, done);
  }

  onPut(object: PessoaJuridica, done: any) {
    this._restService.onPut(apiName, object, done);
  }

  onDelete(objectId: number, done: any) {
    this._restService.onDelete(apiName, objectId, done);
  }

  onGetAll(done: any) {
    var filter: any = {"order":"razaoSocial"};
    this._restService.onGetPost(apiName, filter, done);
  }

  onGetById(objectId: any, done: any) {
    this._restService.onGetPostId(apiName, objectId, {}, done);
  }

  onGetApiUrl() {
    return apiName;
  }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/recursos-humanos/pessoa-juridica/shared/pessoa-juridica-api.service.ts
 **/